import { ILocaleKey } from '@faire/web-api--source/indigofair/locale/ILocaleKey';

export namespace IUserTranslatedString {
  /**
   * Return an instance of IUserTranslatedString with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IUserTranslatedString>
  ): IUserTranslatedString =>
    ({
      ...(partial ?? {}),
    }) as IUserTranslatedString;
}

/**
 * A string translated for a user as well as in the original language. If the user's language is the same as the
 *  original, 'original' fields are null. Locale id and key are both populated due to mobile/web discrepancies
 */
export interface IUserTranslatedString {
  /**
   * In the requestor's language
   */
  translated: string | undefined;
  /**
   * In the original language
   */
  original: string | undefined;
  /**
   * Original locale
   */
  original_locale_id: string | undefined;
  /**
   * Original locale key
   */
  original_locale_key: ILocaleKey | undefined;
}
